import React, {Component} from 'react'
import PropTypes from 'prop-types';
import {Nav, NavItem, NavDropdown, MenuItem} from 'react-bootstrap';
import {LinkContainer} from 'react-router-bootstrap';
import map from 'lodash/map'
import sortBy from 'lodash/sortBy'
import isEmpty from 'lodash/isEmpty'
import identity from 'lodash/identity'
import join from 'lodash/join'
import classNames from 'classnames';

class NavigationMenu extends Component {
    static propTypes = {
        menuConfig: PropTypes.object,
        onCallbackMenuItemClick: PropTypes.func,
        onCreateMenuItemLabel: PropTypes.func,
        isDropdownMenu: PropTypes.bool,
    };

    static defaultProps = {
        onCallbackMenuItemClick: () => {},
        onCreateMenuItemLabel: identity,
    };

    createIconAndLabel = (menuItem) => {
        const {icon, label, description} = menuItem;
        if (!icon) {
            return label;
        }
        const iconControl = <i className={icon} title={description}/>;
        if (!label) {
            return iconControl;
        }
        return <span>{iconControl}{' '}{label}</span>;
    };

    createLeafItem = (menuItem, idx, level, path) => {
        const {isDropdownMenu, onCallbackMenuItemClick, onCreateMenuItemLabel} = this.props;
        const {cssClass, divider, disabled, router, props, description, role, callback, link, dynamicLabel} = menuItem;
        const iconAndLabel = dynamicLabel ? onCreateMenuItemLabel(path) : this.createIconAndLabel(menuItem);
        if (divider) {
            return <MenuItem key={idx} eventKey={-1} divider className={cssClass}/>;
        }
        if (disabled) {
            return <MenuItem key={idx} eventKey={-1} disabled className={cssClass}>{iconAndLabel}</MenuItem>;
        }
        const NavItemComponent = isDropdownMenu ? MenuItem : NavItem;
        if (level === 0 && !router) {
            // regular non-router link on the top menu
            return (
                <NavItemComponent
                    key={idx}
                    href={link}
                    title={description}
                    role={role}
                    {...props}
                >
                    {iconAndLabel}
                </NavItemComponent>
            );
        }
        if (callback) {
            // callback, not a link
            return (
                <MenuItem
                    key={idx}
                    onClick={() => onCallbackMenuItemClick(path)}
                    title={description}
                    role={role}
                    {...props}
                >
                    {iconAndLabel}
                </MenuItem>
            );
        }
        // router link
        return (
            <LinkContainer to={link} key={idx}>
                <NavItemComponent
                    title={description}
                    role={role}
                    className={cssClass}
                    {...props}
                >
                    {iconAndLabel}
                </NavItemComponent>
            </LinkContainer>
        );

    };

    createMenu = (menu, level, path) => {
        const children = map(menu.subMenus, (menuItem, name) => {
            return {...menuItem, name};
        });

        return sortBy(children, 'rank').map((menuItem, idx) => {
            const currPath = [...path, menuItem.name];
            if (isEmpty(menuItem.subMenus)) {
                return this.createLeafItem(menuItem, idx, level, currPath);
            }
            const iconAndLabel = this.createIconAndLabel(menuItem);
            const subItems = this.createMenu(menuItem, level + 1, currPath);
            const key = join(currPath, '-') + '-dropdown';
            return (
                <NavDropdown
                    id={key}
                    key={key}
                    title={iconAndLabel}
                    className={classNames(menuItem.cssClass, key, {'dropdown-submenu': level >= 1})}
                    noCaret={level >= 1}
                    {...menuItem.props}
                >
                    {subItems}
                </NavDropdown>
            );
        });
    };

    render() {
        const {menuConfig, isDropdownMenu, onCallbackMenuItemClick, onCreateMenuItemLabel, ...rest} = this.props;
        if (isEmpty(menuConfig)) {
            return false;
        }
        const items = this.createMenu(menuConfig, isDropdownMenu ? 1 : 0, []);

        if (isDropdownMenu) {
            return items;
        }

        return (
            <Nav {...rest}>
                {items}
            </Nav>
        );
    }
}

export default NavigationMenu;



// WEBPACK FOOTER //
// ./src/components/NavigationMenu.js